module.exports = __webpack_public_path__ + "static/media/shiny-happy-people-desktop.f21fa66e.svg";